module.exports = __webpack_public_path__ + "static/media/journals.e6d5fba6.png";